/* eslint-disable array-callback-return */
/* eslint-disable no-self-assign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import EditIcon from "@mui/icons-material/Edit";
import {
  Alert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Link,
  MenuItem,
  Paper as MuiPaper,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { Add as AddIcon, Download } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { withStyles } from "@mui/styles";
import axios from "../../CustomAxios";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import { CSVLink } from "react-csv";
import moment from "moment";
import ProductionReporFilter from "./ProductionReportFilter";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);
const StyledTableContainer = withStyles((theme) => ({
  root: {
    position: "relative",
  },
}))(TableContainer);
const Spacer = styled.div`
  flex: 1 1 100%;
`;
const ToolbarTitle = styled.div`
  min-width: 150px;
`;
const StickyFooterCell = styled(TableCell)({
  fontWeight: 'bold',
  backgroundColor: '#f5f5f5',
  position: 'sticky',
  bottom: 0,
  zIndex: 2,
});

function createData(
  id,
  job_id,
  job_name,
  customer_name,
  docket_by,
  category,
  plate_name,
  date,
  baking_quantity,
  ctp_quantity,
  action_by,
  challan_id,
  bill_id,
  comment,
  plates,
  jobPlates,
  ap_machine,
  ap_machine_name,
  total_cost,
  not_to_bill,          // <-- new
  production_rejection  // <-- new
) {
  return {
    id,
    job_id,
    job_name,
    customer_name,
    docket_by,
    category: category || "",
    plate_name,
    date,
    baking_quantity: Number(baking_quantity) || 0,
    ctp_quantity: Number(ctp_quantity) || 0,
    action_by,
    challan_id,
    bill_id,
    comment,
    plates,
    jobPlates,
    ap_machine,
    ap_machine_name,
    total_cost: total_cost || 0,
    not_to_bill: not_to_bill ? "Yes" : "No",          // <-- display value
    production_rejection: production_rejection ? "Yes" : "No"  // <-- display value
  };
}

// headCells now includes Not to Bill and Production Rejection columns
const headCells = [
  { key: "date", alignment: "left", label: "Created At" },
  { key: "job_id", alignment: "left", label: "Job ID" },
  { key: "job_name", alignment: "left", label: "Job Name" },
  { key: "customer_name", alignment: "left", label: "Customer Name" },
  { key: "docket_by", alignment: "left", label: "Docket By" },
  { key: "category", alignment: "left", label: "Category" },
  { key: "plate_name", alignment: "left", label: "Plate Name" },
  { key: "action_by", alignment: "left", label: "Plate Made by" },
  { key: "challan_id", alignment: "left", label: "Challan Id" },
  { key: "bill_id", alignment: "left", label: "Bill Id" },
  { key: "baking_quantity", alignment: "left", label: "Baking Quantity" },
  { key: "ctp_quantity", alignment: "left", label: "CTP Quantity" },
  { key: "total_cost", alignment: "left", label: "Cost" },
  { key: "ap_machine_name", alignment: "left", label: "AP Machine" },
  { key: "comment", alignment: "left", label: "Comment" },
  { key: "not_to_bill", alignment: "left", label: "Not to Bill" },           // <-- new
  { key: "production_rejection", alignment: "left", label: "Production Rejection" }, // <-- new
];

const EnhancedTableHead = (props) => {
  const { viewPermission, editPermission } = props;
  const [head, setHeads] = useState(headCells);

  useEffect(() => {
    if (viewPermission) {
      setHeads((prev) => [
        ...prev,
        { key: "view", alignment: "center", label: "View" },
      ]);
    }
  }, [viewPermission, editPermission]);

  return (
    <TableHead>
      <TableRow>
        {head.map((headCell) => (
          <TableCell
            key={headCell.key}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  const {
    rows,
    apCompanies,
    selectedApCompany,
    setSelectedApCompany,
    plates,
    selectedPlate,
    setSelectedPlate,
    searchJob,
    setSearchJob,
    createdBy,
    setCreatedBy,
    apUsers,
    onFilter,
    height,
    width,
    thickness,
    setHeight,
    setWidth,
    setThickness,
    createdDateFrom,
    setCreatedDateFrom,
    createdDateTo,
    setCreatedDateTo,
    csvPermission,
    auths,
  } = props;
  const navigate = useNavigate();
  const timestamp = moment().format("DD-MM-YY HH:mm");
  const csvReport = {
    filename: `${apCompanies.find((item) => item._id === selectedApCompany)?.name || "DPR"
      }_DPR_${timestamp}.csv`,
    headers: headCells,   // CSV uses the same headCells array (now includes new columns)
    data: rows.map((row) => ({
      ...row,
      date: moment(row.date).format("DD/MM/YYYY, hh:mm:ss a"),
    })),
  };

  return (
    <Toolbar>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
        <ToolbarTitle>
          <Typography variant="h6" component="div">
            DPR
          </Typography>
        </ToolbarTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box sx={{ width: 300 }}>
            <FormControl fullWidth size="small">
              <InputLabel id="company-select-label">Select AP Company</InputLabel>
              <Select
                labelId="company-select-label"
                value={selectedApCompany}
                onChange={(e) => setSelectedApCompany(e.target.value)}
                label="Select AP Company"
                sx={{
                  ".MuiSelect-select": {
                    py: 1,
                    "@media (max-width: 600px)": {
                      fontSize: "0.875rem",
                    },
                  },
                }}
              >
                {apCompanies.map((u) => (
                  <MenuItem key={u._id} value={u._id}>
                    {u.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          {csvPermission && (
            <Box>
              <CSVLink
                style={{ textDecoration: "none", display: "block" }}
                {...csvReport}
              >
                <Button
                  variant="outlined"
                  fullWidth
                  startIcon={<Download fontSize="small" />}
                  sx={{
                    py: 1,
                    "@media (max-width: 600px)": {
                      fontSize: "0.875rem",
                    },
                  }}
                >
                  Export CSV
                </Button>
              </CSVLink>
            </Box>
          )}
          <ProductionReporFilter
            createdBy={createdBy}
            setCreatedBy={setCreatedBy}
            searchJob={searchJob}
            setSearchJob={setSearchJob}
            plates={plates}
            selectedPlate={selectedPlate}
            setSelectedPlate={setSelectedPlate}
            height={height}
            width={width}
            thickness={thickness}
            setHeight={setHeight}
            setThickness={setThickness}
            setWidth={setWidth}
            apUsers={apUsers}
            onFilter={onFilter}
            createdDateFrom={createdDateFrom}
            setCreatedDateFrom={setCreatedDateFrom}
            createdDateTo={createdDateTo}
            setCreatedDateTo={setCreatedDateTo}
          />
        </Box>
      </Box>
    </Toolbar>
  );
};

const getApCompanies = async (
  setLoader,
  setApCompanies,
  setSelectedApCompany,
  selectedApCompany
) => {
  const userData = JSON.parse(localStorage.getItem("AuthData"));
  const config = {
    headers: {
      Authorization: "Bearer " + userData.access_token,
    },
  };
  const { data } = await axios.get(
    `/api/v1/${userData?.type}/plate_inventory/inward_outward/ap_companies`,
    config
  );
  const companies = data.data;
  setApCompanies(companies);
  if (companies && companies.length > 0 && !selectedApCompany) {
    setSelectedApCompany(companies[0]._id);
  }
};

const getPlates = async (setPlates) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    if (userData?.type === "ap_user" || userData?.type === "super_admin") {
      const { data } = await axios.get(
        `/api/v1/${userData?.type}/plate_inventory?page=0&limit=500`,
        config
      );
      if (data.success) {
        setPlates(data.data.data);
      }
    }
  } catch (e) {
    console.log("error in plates", e);
  }
};

const getApUsers = async (selectedCompany, setApUsers, setLoader) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    let url = `/api/v1/${authData?.type}/plate_inventory/inward_outward/ap_users?ap_company=${selectedCompany}`;
    const apUsers = await axios.get(url, config);
    if (apUsers.data.success) {
      let finalData = apUsers.data.data;
      if (authData.type === "super_admin") {
        let user = {
          name: "super_admin",
          _id: authData.user_id,
        };
        finalData.push(user);
      }
      let presentUserIndex = finalData.findIndex(
        (u) => u._id === authData.user_id
      );
      if (presentUserIndex >= 0) {
        finalData.forEach(function (item, i) {
          if (item._id === authData.user_id) {
            finalData.splice(i, 1);
            finalData.unshift(item);
          }
        });
      }
      setApUsers(finalData);
    }
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function EnhancedTable({
  rows,
  apCompanies,
  selectedApCompany,
  setSelectedApCompany,
  editPermission,
  viewPermission,
  createdBy,
  setCreatedBy,
  apUsers,
  onFilter,
  plates,
  setSelectedPlate,
  selectedPlate,
  searchJob,
  setSearchJob,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  total_results,
  createdDateFrom,
  setCreatedDateFrom,
  createdDateTo,
  setCreatedDateTo,
  csvPermission,
  auths,
}) {
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);
  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  useEffect(() => {
    if (location?.state?.success) {
      snackRef.current.click();
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Calculate page totals
  const totalBaking = rows.reduce((sum, row) => sum + (row.baking_quantity || 0), 0);
  const totalCtp = rows.reduce((sum, row) => sum + (row.ctp_quantity || 0), 0);
  const totalCost = rows.reduce((sum, row) => sum + (row.total_cost || 0), 0);

  // Find column indices for colSpan (automatically updated because headCells now includes new columns)
  const bakingIndex = headCells.findIndex(cell => cell.key === "baking_quantity");
  const ctpIndex = headCells.findIndex(cell => cell.key === "ctp_quantity");
  const costIndex = headCells.findIndex(cell => cell.key === "total_cost");
  const commentIndex = headCells.findIndex(cell => cell.key === "comment");
  // Adjust indices for action columns
  const actionColumnCount = (viewPermission ? 1 : 0) + (editPermission ? 1 : 0);
  const totalColumns = headCells.length + actionColumnCount;

  return (
    <div>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        <Alert mt={2} mb={4} severity="success">
          {message}
        </Alert>
      </Snackbar>
      <Paper>
        <EnhancedTableToolbar
          rows={rows}
          apCompanies={apCompanies}
          selectedApCompany={selectedApCompany}
          setSelectedApCompany={setSelectedApCompany}
          numSelected={selected.length}
          searchJob={searchJob}
          setSearchJob={setSearchJob}
          plates={plates}
          selectedPlate={selectedPlate}
          setSelectedPlate={setSelectedPlate}
          createdBy={createdBy}
          setCreatedBy={setCreatedBy}
          apUsers={apUsers}
          onFilter={onFilter}
          createdDateFrom={createdDateFrom}
          setCreatedDateFrom={setCreatedDateFrom}
          createdDateTo={createdDateTo}
          setCreatedDateTo={setCreatedDateTo}
          csvPermission={csvPermission}
          auths={auths}
        />
        {rows.length === 0 ? (
          <Box
            sx={{
              height: "calc(100vh - 266px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h5">
              No DPR Entries for{" "}
              {
                apCompanies.filter((item) => item._id === selectedApCompany)[0]
                  .name
              }{" "}
              💽
            </Typography>
          </Box>
        ) : (
          <>
            <StyledTableContainer>
              <Table size={"small"}>
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rows.length}
                  viewPermission={viewPermission}
                  editPermission={editPermission}
                />
                <TableBody>
                  {rows.map((row, index) => {
                    const isItemSelected = isSelected(row.id);
                    return (
                      <TableRow
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={`${row.id}-${index}`}
                        selected={isItemSelected}
                      >
                        <TableCell align="left">
                          {new Date(row.date).toLocaleString("en-IN")}
                        </TableCell>
                        <TableCell align="left">{row.job_id}</TableCell>
                        <TableCell align="left">{row.job_name}</TableCell>
                        <TableCell align="left">{row.customer_name}</TableCell>
                        <TableCell align="left">{row.docket_by}</TableCell>
                        <TableCell align="left">{row.category}</TableCell>
                        <TableCell align="left">{row.plate_name}</TableCell>
                        <TableCell align="left">{row.action_by}</TableCell>
                        <TableCell align="left">{row.challan_id}</TableCell>
                        <TableCell align="left">{row?.bill_id}</TableCell>
                        <TableCell align="left">
                          {row.baking_quantity.toLocaleString()}
                        </TableCell>
                        <TableCell align="left">
                          {row.ctp_quantity.toLocaleString()}
                        </TableCell>
                        <TableCell align="left">
                          {row.total_cost.toLocaleString()}
                        </TableCell>
                        <TableCell align="left">
                          {row?.ap_machine?.name && row?.ap_machine?.serial_no
                            ? `${row.ap_machine.name} - ${row.ap_machine.serial_no}`
                            : "--"}
                        </TableCell>
                        <TableCell align="left">{row.comment}</TableCell>
                        <TableCell align="left">{row.not_to_bill}</TableCell>          {/* <-- new */}
                        <TableCell align="left">{row.production_rejection}</TableCell> {/* <-- new */}
                        {viewPermission ? (
                          <TableCell align="center">
                            <VisibilityIcon
                              style={{ color: "green", cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  `/dashboard/production-report/view/${row.id}`,
                                  {
                                    state: { id: row.id },
                                  }
                                )
                              }
                            />
                          </TableCell>
                        ) : null}
                      </TableRow>
                    );
                  })}
                </TableBody>
                {/* Footer with totals */}
                <TableFooter>
                  <TableRow>
                    <StickyFooterCell
                      colSpan={bakingIndex}
                      align="right"
                    >
                      Page Totals
                    </StickyFooterCell>
                    <StickyFooterCell>
                      {totalBaking.toLocaleString()}
                    </StickyFooterCell>
                    <StickyFooterCell>
                      {totalCtp.toLocaleString()}
                    </StickyFooterCell>
                    <StickyFooterCell>
                      {totalCost.toLocaleString()}
                    </StickyFooterCell>
                    <StickyFooterCell colSpan={totalColumns - costIndex - 1} />
                  </TableRow>
                </TableFooter>
              </Table>
            </StyledTableContainer>
            <TablePagination
              rowsPerPageOptions={[50, 100, 250]}
              component="div"
              count={total_results}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        )}
      </Paper>
    </div>
  );
}

function ProductionReport({ auths }) {
  const token = JSON.parse(localStorage.getItem("AuthData"));
  const [loader, setLoader] = useState(true);
  const [editPermission, setEditPermission] = useState(false);
  const [viewPermission, setViewPermission] = useState(false);
  const [createPermission, setCreatePermission] = useState(false);
  const [csvPermission, setCsvPermission] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [createdBy, setCreatedBy] = useState(searchParams.get("created_by"));
  const [apUsers, setApUsers] = useState(null);
  const [page, setPage] = React.useState(
    searchParams.get("page") ? Number(searchParams.get("page")) : 0
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    searchParams.get("limit") ? Number(searchParams.get("limit")) : 50
  );
  const [createdDateFrom, setCreatedDateFrom] = useState(
    searchParams.get("created_from") || ""
  );
  const [createdDateTo, setCreatedDateTo] = useState(
    searchParams.get("created_to") || ""
  );
  const [selectedPlate, setSelectedPlate] = useState(
    searchParams.get("plate") || ""
  );
  const [total, setTotal] = useState(0);
  const location = useLocation();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    changeParams(newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    changeParams(0, event.target.value);
  };

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const snackRef = useRef(null);
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const changeParams = (queryPage, queryLimit, selectedApCompany) => {
    let query = `?ap_company=${selectedApCompany}&page=${queryPage}&limit=${queryLimit}`;
    let created_by = searchParams.get("created_by") || "";
    let created_from = searchParams.get("created_from") || "";
    let created_to = searchParams.get("created_to") || "";
    let plate = searchParams.get("plate") || "";
    let job_search = searchParams.get("job_search") || "";
    if (created_by) {
      query += `&created_by=${created_by}`;
    }
    if (created_from) {
      query += `&created_from=${created_from}`;
    }
    if (created_to) {
      query += `&created_to=${created_to}`;
    }
    if (plate) {
      query += `&plate=${plate}`;
    }
    if (job_search) {
      query += `&job_search=${job_search}`;
    }
    navigate("/dashboard/production-report" + query, {
      replace: true,
    });
  };

  const calculateRowCost = (data) => {
    let plateCost = 0;
    const plates = data.job_id.plates;
    const jobPlate = data.plate;

    if (plates.length > 1) {
      for (let i = 0; i < plates.length; i++) {
        if (jobPlate._id === plates[i]._id) {
          plateCost += Number(plates[i].print_cost || 0) * Number(plates[i].printout || 0);
          plateCost += Number(plates[i].selling_cost || 0) * Number(plates[i].ctp_plate_count || 0);
        }
      }
    } else if (plates.length === 1) {
      const p = plates[0];
      const total_print_cost = Number(p.print_cost || 0) * Number(p.printout || 0);
      const total_selling_cost = Number(p.selling_cost || 0) * Number(p.ctp_plate_count || 0);
      plateCost = total_print_cost + total_selling_cost;
    }
    return plateCost;
  };

  const getProductionReport = async (params = {}) => {
    let queryPage = searchParams.get("page");
    let queryLimit = searchParams.get("limit");
    setLoader(true);
    let { created_by, plate_data, job_search } = params;
    try {
      const config = {
        headers: {
          Authorization: "Bearer " + token.access_token,
        },
      };
      let url = `/api/v1/${token?.type}/production_report?`;
      queryPage ? (queryPage = Number(queryPage) + 1) : (queryPage = page + 1);
      queryLimit ? (queryLimit = queryLimit) : (queryLimit = rowsPerPage);
      url += `&page=${queryPage}&limit=${queryLimit}&created_from=${createdDateFrom}&created_to=${createdDateTo}`;
      let rows = [];
      url += "&ap_company=" + selectedApCompany;
      if (created_by) url += `&created_by=${created_by}`;
      if (plate_data) url += `&plate=${plate_data}`;
      if (job_search) url += `&job_search=${job_search}`;
      const { data } = await axios.get(url, config);
      if (data.success) {
        const result = data.data.data;
        setTotal(data.data.metadata.total_results);
        result.map((data) => {
          let plate = data.plate;
          if (plate !== null && data.job_id !== null) {
            let plate_name = `${plate.height}X${plate.width}X${plate.thickness} | ${plate.brand.name} | ${plate.technology.name}`;

            // Extract not_to_bill and production_rejection from job plates
            let not_to_bill = false;
            let production_rejection = false;
            const jobPlates = data.job_id?.plates || [];
            const currentPlateEntry = jobPlates.find(p => p.plate_id === plate._id);
            if (currentPlateEntry) {
              not_to_bill = currentPlateEntry.not_to_bill || false;
              production_rejection = currentPlateEntry.production_rejection || false;
            }

            // Cost from backend (already calculated as (print + selling) * ctp_quantity)
            const total_cost = data.plate_cost;

            rows.push(
              createData(
                data._id,
                data.job_id.job_id,
                data.job_id.name,
                data.job_id.customer_company.name,
                data.job_id.docket_details.action_by.name,
                data.job_id.category,
                plate_name,
                data.createdAt,
                data.baking_quantity,
                data.ctp_quantity,
                data.audit_logs[0].action_by.name,
                data.job_id.challan_created === true
                  ? data.job_id.associated_challan.challan_id
                  : "",
                data.job_id.bill_created === true &&
                  data.job_id.associated_bill !== null
                  ? data.job_id.associated_bill.bill_id
                  : "",
                data.comment,
                data.job_id.plates,
                data.plate,
                data.ap_machine,
                data?.ap_machine?.name ? `${data.ap_machine?.name} - ${data.ap_machine?.serial_no}` : "",
                total_cost,
                not_to_bill,          // <-- pass new flag
                production_rejection  // <-- pass new flag
              )
            );
          }
        });
      }
      setRows(rows);
      setLoader(false);
    } catch (e) {
      console.log(e);
    }
    setLoader(false);
  };

  const onFilter = () => {
    let url = `/dashboard/production-report?ap_company=${selectedApCompany}&page=${page}&limit=${rowsPerPage}`;
    if (createdBy) url += `&created_by=${createdBy}`;
    if (createdDateFrom) url += `&created_from=${createdDateFrom}`;
    if (createdDateTo) url += `&created_to=${createdDateTo}`;
    if (selectedPlate) url += `&plate=${selectedPlate}`;
    if (searchJob) url += `&job_search=${searchJob}`;
    navigate(url, {
      replace: true,
    });
    let params = {
      created_by: createdBy,
      plate_data: selectedPlate,
      job_search: searchJob,
    };
    setPage(0);
    setRowsPerPage(50);
    getProductionReport(params);
  };

  useEffect(() => {
    if (auths?.user?.role?.permissions.includes("update_dpr")) {
      setEditPermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("view_dpr") ||
      token?.type === "super_admin"
    ) {
      setViewPermission(true);
    }
    if (auths?.user?.role?.permissions.includes("create_dpr")) {
      setCreatePermission(true);
    }
    if (
      auths?.user?.role?.permissions.includes("download_csv") ||
      token?.type === "super_admin"
    ) {
      setCsvPermission(true);
    }
  }, []);

  const returnParam = (value) => {
    return searchParams.get(value);
  };

  const [rows, setRows] = useState([]);
  const [apCompanies, setApCompanies] = useState([]);
  const [selectedApCompany, setSelectedApCompany] = useState(
    returnParam("ap_company")
  );
  const [searchJob, setSearchJob] = useState(returnParam("job_search"));
  const [plates, setPlates] = useState([]);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(location?.state?.success);

  useEffect(() => {
    if (selectedApCompany) {
      let params = {
        created_by: returnParam("created_by"),
        plate_data: returnParam("plate"),
        job_search: returnParam("job_search"),
      };
      changeParams(page, rowsPerPage, selectedApCompany);
      getApUsers(selectedApCompany, setApUsers, setLoader);
      getProductionReport(params);
    }
  }, [selectedApCompany, page, rowsPerPage]);

  useEffect(async () => {
    getApCompanies(
      setLoader,
      setApCompanies,
      setSelectedApCompany,
      selectedApCompany
    );
  }, []);

  useEffect(() => {
    getPlates(setPlates);
  }, []);

  if (!loader) {
    return (
      <React.Fragment>
        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          {err ? (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          ) : success ? (
            <Alert mt={2} mb={4} severity="success">
              Challan Updated Successfully
            </Alert>
          ) : null}
        </Snackbar>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              DPR
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/inventory">
                Inventory
              </Link>
              <Typography>In-Out</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable
              rows={rows}
              apCompanies={apCompanies}
              selectedApCompany={selectedApCompany}
              setSelectedApCompany={setSelectedApCompany}
              setRows={setRows}
              viewPermission={viewPermission}
              editPermission={editPermission}
              plates={plates}
              selectedPlate={selectedPlate}
              setSelectedPlate={setSelectedPlate}
              searchJob={searchJob}
              setSearchJob={setSearchJob}
              createdBy={createdBy}
              setCreatedBy={setCreatedBy}
              apUsers={apUsers}
              onFilter={onFilter}
              page={page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              total_results={total}
              createdDateFrom={createdDateFrom}
              setCreatedDateFrom={setCreatedDateFrom}
              createdDateTo={createdDateTo}
              setCreatedDateTo={setCreatedDateTo}
              csvPermission={csvPermission}
              auths={auths}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(ProductionReport);